module.exports = __webpack_public_path__ + "img/TBISYSCS4.70abc513.jpg";